/* istanbul ignore file */
import React from 'react';
import { PROCESS_STATE_CAPTIONS } from 'domain/gpo/cockpit/instance/processInstanceService';
import { EqCondition } from 'framework/list';
import { EnumDropdown } from 'framework/form';

const ProcessStateFilter = (props: any) => {
  return (
    <EqCondition {...props}>
      <EnumDropdown {...props} placeholder="Choose Process State" options={PROCESS_STATE_CAPTIONS} />
    </EqCondition>
  );
};

export default ProcessStateFilter;
